import React, { useState, useEffect } from 'react';
import { Card, Upload, Button, message, Row, Col } from 'antd';
import { UploadOutlined, FilePdfOutlined } from '@ant-design/icons';
import axios from 'axios';

const CSupermercadoCliente = () => {
  const [ofertas, setOfertas] = useState(null);
  const [loading, setLoading] = useState(false);
  const [empresaData, setEmpresaData] = useState(null);

  const user = JSON.parse(localStorage.getItem('user'));
  const empresaId = user?.user?.idCooperativa;

  useEffect(() => {
    const fetchEmpresaData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/empresa/${empresaId}`);
        setEmpresaData(response.data);
      } catch (error) {
        console.error('Error al cargar datos de la empresa:', error);
        message.error('Error al cargar los datos de la empresa');
      }
    };

    if (empresaId) {
      fetchEmpresaData();
    }
  }, [empresaId]);

  const uploadProps = {
    beforeUpload: (file) => {
      const isPDF = file.type === 'application/pdf';
      if (!isPDF) {
        message.error('Solo se permiten archivos PDF.');
        return false;
      }
      // Verificar tamaño del archivo (ejemplo: máximo 5MB)
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error('El archivo debe ser menor a 5MB.');
        return false;
      }
      setOfertas(file);
      return false;
    },
  };

  const handleUpload = async () => {
    if (!ofertas) {
      message.warning('Por favor selecciona un archivo PDF antes de subir.');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('section', 'supermercado');
    formData.append('ofertas', ofertas);

    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/empresa/${empresaId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      message.success('PDF actualizado exitosamente.');
      setEmpresaData(response.data);
      setOfertas(null);
    } catch (error) {
      console.error('Error al actualizar el PDF:', error);
      message.error('Hubo un error al subir el PDF.');
    } finally {
      setLoading(false);
    }
  };

  const renderPDFPreview = (file, pdfUrl) => {
    if (file) {
      return (
        <div className="pdf-preview">
          <FilePdfOutlined style={{ fontSize: '48px', color: '#ff4d4f' }} />
          <p>{file.name}</p>
        </div>
      );
    } else if (pdfUrl) {
      return (
        <div className="pdf-preview">
          <FilePdfOutlined style={{ fontSize: '48px', color: '#1890ff' }} />
          <p>PDF actual</p>
          <Button 
            type="link" 
            onClick={() => window.open(`${process.env.REACT_APP_S3_URL}/${pdfUrl}`, '_blank')}
          >
            Ver PDF
          </Button>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="p-4">
      <Card title="Supermercado" className="mb-4">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Card title="Ofertas de supermercado">
              <Upload {...uploadProps} accept=".pdf">
                <Button icon={<UploadOutlined />}>Seleccionar PDF</Button>
              </Upload>
              <div style={{ marginTop: '16px', textAlign: 'center' }}>
                {renderPDFPreview(ofertas, empresaData?.supermercado?.[0]?.ofertas)}
              </div>
            </Card>
          </Col>
        </Row>

        <Button
          type="primary"
          onClick={handleUpload}
          loading={loading}
          disabled={!ofertas}
          style={{ marginTop: '16px' }}
        >
          Actualizar PDF
        </Button>

        <style jsx>{`
          .pdf-preview {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 16px;
            border: 1px dashed #d9d9d9;
            border-radius: 4px;
            background-color: #fafafa;
          }
          .pdf-preview p {
            margin: 8px 0;
          }
        `}</style>
      </Card>
    </div>
  );
};

export default CSupermercadoCliente;